const modsTabs = (cfg)=>({
        ...cfg,
        datatype: [
            1
        ],
        tabGroup: 'formats',
        minorTabGroup: 'mods',
        acl: 'g:editMetadataMods'
    });
export const tree = {
    tabs: {
        modsedit: modsTabs({
            label: 'Editor',
            parts: [
                'ModsEditor'
            ],
            tabGroupDefault: true,
            order: 10
        }),
        modstab: modsTabs({
            label: 'Tabular',
            parts: [
                {
                    type: 'ModsRenderer',
                    filters: [
                        'getModsRendered'
                    ]
                }
            ]
        }),
        rawcat: modsTabs({
            label: 'RawCat',
            cfg: ({ dconfig })=>dconfig.mods?.source == 'rawcat' || dconfig.connectors?.sru.useRawCatalogData,
            parts: [
                'ModsRawCat'
            ]
        }),
        modshist: modsTabs({
            label: 'History',
            parts: [
                {
                    type: 'ModsHist',
                    filters: [
                        {
                            type: 'getModsHistory',
                            withText: false
                        }
                    ]
                }
            ]
        }),
        modsgen: modsTabs({
            label: 'Generate',
            parts: [
                'ModsGenerate'
            ]
        }),
        modsdiff: modsTabs({
            label: 'Diff',
            parts: [
                'ModsDiff'
            ]
        })
    }
};
